import {
    GET_AMAZON_PRODUCT_UPDATE_NEW_REQUEST,
    GET_AMAZON_PRODUCT_UPDATE_NEW_SUCCESS,
    GET_AMAZON_PRODUCT_UPDATE_NEW_ERROR
} from "../actions/types"
export default function (state = [], action) {
    const { type, payload } = action;
    switch (type) {
        case GET_AMAZON_PRODUCT_UPDATE_NEW_REQUEST:
            return {
                loading: true,
            };
        case GET_AMAZON_PRODUCT_UPDATE_NEW_SUCCESS:
            return {
                ...state,
                loading: false,
                payload,
            };
        case GET_AMAZON_PRODUCT_UPDATE_NEW_ERROR:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
}